// DimensionsDetails.js
import {useState} from "react";
import ToolTip from "@/components/ui/tooltip/ToolTip";

import DetailsComponent from "@/components/ui/cards/DetailsComponent";
import BootSpace from "@/components/ev-details/BootSpace";
import styles from "@/components/ev-details/DimensionsDetails.module.css";

const DimensionsDetails = ({data}) => {
  const [showAdvanced, setShowAdvanced] = useState(false);

  const handleToggle = (newState) => {
    setShowAdvanced(newState);
  };

  const sortedData = data.sort((a, b) => a.cw_position - b.cw_position);

  return (
    <DetailsComponent
      title="Dimensions and drivetrain"
      showToggle={true}
      onToggle={handleToggle}>
      <div className={styles.detailBox}>
        {sortedData.map((detail, index) => {
          if (detail.advanced && !showAdvanced) {
            return null;
          }
          if (
            detail.label === "Boot space" &&
            (!detail.value ||
              detail.value === "None" ||
              detail.value === "null")
          ) {
            return null;
          }
          return (
            <div className={styles.detailBoxContent} key={index}>
              {detail.label === "Boot space" ? (
                <div className={styles.detail}>
                  <BootSpace litres={parseInt(detail.value)}/>
                  <div className={styles.detailLabel2}>{detail.label}</div>
                </div>
              ) : (
                <div className={styles.detail}>
                  <div className={styles.detailData}>
                    <span className={styles.detailValue}>{detail.value}</span>{" "}
                    <span className={styles.detailUnit}>
                      {detail.unit ? ` ${detail.unit}` : ""}
                    </span>
                  </div>
                  <div className={styles.detailLabel}>{detail.label}</div>
                  {detail.description && (
                    <ToolTip tooltipText={detail.description}>
                      <span>?</span>
                    </ToolTip>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </DetailsComponent>
  );
};

export default DimensionsDetails;
